export default {
  title: {
    id: 'seo_article_related_articles_title',
    defaultMessage: 'Related articles',
  },
} as const
